import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';

import { ButtonBox } from '../molecules/button-box';
import { trpc } from '../api/trpc';

export const AppMessagesDelete = () => {
  const confirm = useConfirm();

  const deleteAppMessages = trpc.deleteAppMessages.useMutation();

  const handleClick = () => {
    confirm({
      title: (
        <FormattedMessage
          id="app_messages.confirm.title"
          defaultMessage="Opravdu chcete smazat všechny zprávy?"
        />
      ),
      confirmationText: (
        <FormattedMessage id="app_messages.confirm" defaultMessage="Smazat" />
      ),
      cancellationText: (
        <FormattedMessage id="app_messages.cancel" defaultMessage="Zrušit" />
      ),
    })
      .then(() => {
        return deleteAppMessages.mutateAsync();
      })
      .catch(() => {
        // noop
      });
  };

  return (
    <ButtonBox
      title={
        <FormattedMessage
          id="app_messages.title"
          defaultMessage="Smazat všechny zprávy"
        />
      }
      buttonLabel={
        <FormattedMessage id="app_messages.button" defaultMessage="Smazat" />
      }
      onClick={handleClick}
      fullWidth
    />
  );
};
